import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DocumentTitle, Page} from '../widgets';
import Form from '../widgets/FormV2';
import sessionActions from '../user/session.actions';
import FancyButton from '../widgets/FancyButton';
import uiActions from '../chrome/ui.actions';
import {push} from 'connected-react-router';
import PickerField from './PickerField';
import getGettingStartedProgress from './gettingStartedProgress';
import CommunityCard from '../community/CommunityCard';
import fetchJson, {postJson, deleteJson} from '../fetchJson';
import './GettingStarted.css';
import {GettingStartedFooter} from './GettingStarted';
import handleError from '../handleError';
import Icon from '../widgets/Icon';
import CardButton from '../widgets/CardButton';

const getSessionProvider = props => props && props.currentSession && props.currentSession.provider;
const getSessionUser = props => props && props.currentSession && props.currentSession.user;

class GettingStartedCommunity extends Component {
	constructor(props) {
		super(props);

		this.state = {memberships: []};

		this.next = () => this.props.next(getSessionProvider(this.props).subscriptionLevel);
		this.previous = () => this.props.previous();
	}

	componentDidMount() {
		this.initialiseCommunities();
	}

	showCommunityPicker = category => {
		this.props.showCommunityPicker(community => this.addMembership(community), category);
	};

	addMembership = community => {
		const memberships = this.state.memberships || [];
		postJson(
			`/api/community/${community.uuid}/members/${getSessionUser(this.props).uuid}`,
			{}
		).catch(e => (e.name === '400' ? {} : this.props.handleError(e))); // Ignore 400 here, user is already a member
		this.setState({
			memberships: memberships.filter(m => m.uuid !== community.uuid).concat(community)
		});
	};

	leaveCommunity = uuid => {
		const memberships = this.state.memberships || [];
		if (memberships.find(m => m.uuid === uuid)) {
			const {uuid: userUuid} = getSessionUser(this.props) || {};
			deleteJson(`/api/community/${uuid}/members/${userUuid}`).catch(this.props.handleError);

			this.setState({
				memberships: memberships.filter(m => m.uuid !== uuid)
			});
		}
	};

	/**
	 * Select a community via uuid
	 */
	selectCommunity = uuid => {
		const memberships = this.state.memberships || [];
		this.addMembership(memberships.find(c => c.uuid === uuid));
	};

	initialiseCommunities = () => {
		const {signupCommunity} = this.props;

		if (signupCommunity) {
			fetchJson('/api/community/?profileUniqueName=' + signupCommunity)
				.then(prepopCommunity => this.addMembership(prepopCommunity))
				.catch(e => (e.name === '400' ? {} : this.props.handleError(e)));
		}

		this.retrieveExisting();
	};

	retrieveExisting = () => {
		const {uuid: userUuid} = getSessionUser(this.props) || {};

		if (userUuid && !this.state.retrievedExisting) {
			this.setState({retrievedExisting: true});
			fetchJson(`/api/community/?userUuid=${userUuid}&includePending=true`)
				.then(existingMemberships =>
					existingMemberships.length
						? this.setState({
								retrievedExisting: true,
								memberships: this.state.memberships.concat(existingMemberships)
						  })
						: null
				)
				.catch(this.props.handleError);
		}
	};

	componentDidUpdate() {
		this.retrieveExisting();
	}

	render() {
		if (!getSessionProvider(this.props)) return null;

		return (
			<PresentationalGettingStartedCommunity
				communities={this.state.memberships}
				communityCategories={this.props.communityCategories}
				progress={getGettingStartedProgress(
					getSessionUser(this.props),
					getSessionProvider(this.props)
				)}
				selectCommunity={this.selectCommunity}
				leaveCommunity={this.leaveCommunity}
				next={this.next}
				previous={this.previous}
				showCommunityPicker={this.showCommunityPicker}
			/>
		);
	}
}

export const PresentationalGettingStartedCommunity = ({
	communities,
	communityCategories,
	leaveCommunity,
	next,
	previous,
	progress,
	showCommunityPicker
}) => (
	<DocumentTitle title="B2Me">
		<Page className="GettingStarted scroll-anchor">
			<Form>
				<h3>Communities</h3>
				<p>
					A community membership helps you to get exposure, and to network with others nearby. Note
					that some communities require approval by the administrator in order to confirm your
					membership.
				</p>
				{communities && communities.length ? <p>You are signing up with:</p> : undefined}
				{communities && communities.length ? (
					<ul className="GettingStarted-communities">
						{communities &&
							communities.map(community => (
								<CommunityCard
									className={`GettingStarted-memberships ${community.member ? 'requested' : ''}`}
									key={community.uuid}
									community={community}
									enableLink={false}>
									<CardButton
										onClick={() => leaveCommunity(community.uuid)}
										title="I don't want to sign-up with this community">
										<Icon name="close" />
									</CardButton>
								</CommunityCard>
							))}
					</ul>
				) : (
					undefined
				)}
				{!communities || !communities.length ? (
					<p>
						Explore the marketplace through communities. Click one of the options below to browse:
					</p>
				) : (
					undefined
				)}
				{(!communities || !communities.length) && communityCategories ? (
					<ul className="GettingStarted-communityCategories">
						{communityCategories.map(cat => (
							<CategoryCard key={cat} category={cat} onClick={showCommunityPicker} />
						))}
					</ul>
				) : (
					undefined
				)}
				<GettingStartedFooter
					progress={progress}
					subscriptionLevel={'essential'}
					next={next}
					previous={previous}
				/>
			</Form>
		</Page>
	</DocumentTitle>
);

const CategoryCard = ({category, onClick}) => {
	return (
		<li className="GettingStarted-CategoryCard">
			<button onClick={() => onClick(category)}>{category}</button>
		</li>
	);
};

const ConnectedGettingStartedCommunity = connect(
	({session, categories}) => ({
		categories: categories && categories.provider,
		currentSession: session && session.current,
		signupCommunity: session && session.signupCommunity,
		communityCategories: categories && categories.community
	}),
	dispatch => ({
		showCommunityPicker: (callback, prefill) => {
			dispatch(
				uiActions.uiPickerCallback(community => {
					callback(community);
					dispatch(uiActions.uiModal(null));
				})
			);
			dispatch(uiActions.uiPickerPrefill(prefill));
			dispatch(uiActions.uiModal('community-picker'));
		},
		previous: data => {
			dispatch(push('/getting-started-bio'));
		},
		next: subscriptionLevel => {
			dispatch(
				push(subscriptionLevel === 'none' ? '/getting-started-building' : '/getting-started-images')
			);
		},
		handleError: handleError(dispatch)
	})
)(GettingStartedCommunity);

export default ConnectedGettingStartedCommunity;



// WEBPACK FOOTER //
// ./src/profile/GettingStartedCommunity.js